"use strict";
/*
 * HSTabs
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSTabs = /** @class */ (function (_super) {
    __extends(HSTabs, _super);
    function HSTabs(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        _this.toggles = _this.el.querySelectorAll('[data-hs-tab]');
        _this.extraToggleId = _this.el.getAttribute('data-hs-tab-select');
        _this.extraToggle = document.querySelector(_this.extraToggleId);
        _this.current = Array.from(_this.toggles).find(function (el) {
            return el.classList.contains('active');
        });
        _this.currentContentId = _this.current.getAttribute('data-hs-tab');
        _this.currentContent = document.querySelector(_this.currentContentId);
        _this.prev = null;
        _this.prevContentId = null;
        _this.prevContent = null;
        _this.init();
        return _this;
    }
    HSTabs.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsTabsCollection, this);
        this.toggles.forEach(function (el) {
            el.addEventListener('click', function () { return _this.open(el); });
        });
        if (this.extraToggle) {
            this.extraToggle.addEventListener('change', function (evt) { return _this.change(evt); });
        }
    };
    HSTabs.prototype.open = function (el) {
        var _a, _b;
        this.prev = this.current;
        this.prevContentId = this.currentContentId;
        this.prevContent = this.currentContent;
        this.current = el;
        this.currentContentId = this.current.getAttribute('data-hs-tab');
        this.currentContent = document.querySelector(this.currentContentId);
        if ((_a = this === null || this === void 0 ? void 0 : this.prev) === null || _a === void 0 ? void 0 : _a.ariaSelected)
            this.prev.ariaSelected = 'false';
        this.prev.classList.remove('active');
        this.prevContent.classList.add('hidden');
        if ((_b = this === null || this === void 0 ? void 0 : this.current) === null || _b === void 0 ? void 0 : _b.ariaSelected)
            this.current.ariaSelected = 'true';
        this.current.classList.add('active');
        this.currentContent.classList.remove('hidden');
        this.fireEvent('change', {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId,
        });
        (0, utils_1.dispatch)('change.hs.tab', el, {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId,
        });
    };
    HSTabs.prototype.change = function (evt) {
        var toggle = document.querySelector("[data-hs-tab=\"".concat(evt.target.value, "\"]"));
        if (toggle)
            toggle.click();
    };
    // Static methods
    HSTabs.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsTabsCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSTabs.autoInit = function () {
        if (!window.$hsTabsCollection)
            window.$hsTabsCollection = [];
        document
            .querySelectorAll('[role="tablist"]:not(select):not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsTabsCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSTabs(el);
        });
        if (window.$hsTabsCollection)
            document.addEventListener('keydown', function (evt) { return HSTabs.accessibility(evt); });
    };
    HSTabs.open = function (target) {
        var elInCollection = window.$hsTabsCollection.find(function (el) {
            return Array.from(el.element.toggles).includes(typeof target === 'string' ? document.querySelector(target) : target);
        });
        var targetInCollection = Array.from(elInCollection.element.toggles).find(function (el) {
            return el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (targetInCollection && !targetInCollection.classList.contains('active'))
            elInCollection.element.open(targetInCollection);
    };
    // Accessibility methods
    HSTabs.accessibility = function (evt) {
        var target = document.querySelector('[data-hs-tab]:focus');
        if (target &&
            constants_1.TABS_ACCESSIBILITY_KEY_SET.includes(evt.code) &&
            !evt.metaKey) {
            var isVertical = target
                .closest('[role="tablist"]')
                .getAttribute('data-hs-tabs-vertical');
            evt.preventDefault();
            switch (evt.code) {
                case isVertical === 'true' ? 'ArrowUp' : 'ArrowLeft':
                    this.onArrow();
                    break;
                case isVertical === 'true' ? 'ArrowDown' : 'ArrowRight':
                    this.onArrow(false);
                    break;
                case 'Home':
                    this.onStartEnd();
                    break;
                case 'End':
                    this.onStartEnd(false);
                    break;
                default:
                    break;
            }
        }
    };
    HSTabs.onArrow = function (isOpposite) {
        if (isOpposite === void 0) { isOpposite = true; }
        var target = document
            .querySelector('[data-hs-tab]:focus')
            .closest('[role="tablist"]');
        var targetInCollection = window.$hsTabsCollection.find(function (el) { return el.element.el === target; });
        if (targetInCollection) {
            var toggles = isOpposite
                ? Array.from(targetInCollection.element.toggles).reverse()
                : Array.from(targetInCollection.element.toggles);
            var focused_1 = toggles.find(function (el) { return document.activeElement === el; });
            var focusedInd = toggles.findIndex(function (el) { return el === focused_1; });
            focusedInd = focusedInd + 1 < toggles.length ? focusedInd + 1 : 0;
            toggles[focusedInd].focus();
            toggles[focusedInd].click();
        }
    };
    HSTabs.onStartEnd = function (isOpposite) {
        if (isOpposite === void 0) { isOpposite = true; }
        var target = document
            .querySelector('[data-hs-tab]:focus')
            .closest('[role="tablist"]');
        var targetInCollection = window.$hsTabsCollection.find(function (el) { return el.element.el === target; });
        if (targetInCollection) {
            var toggles = isOpposite
                ? Array.from(targetInCollection.element.toggles)
                : Array.from(targetInCollection.element.toggles).reverse();
            if (toggles.length) {
                toggles[0].focus();
                toggles[0].click();
            }
        }
    };
    // Backward compatibility
    HSTabs.on = function (evt, target, cb) {
        var elInCollection = window.$hsTabsCollection.find(function (el) {
            return Array.from(el.element.toggles).includes(typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSTabs;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSTabs.autoInit();
    // Uncomment for debug
    // console.log('Tabs collection:', window.$hsTabsCollection);
});
if (typeof window !== 'undefined') {
    window.HSTabs = HSTabs;
}
exports.default = HSTabs;
